import { ChangeEvent, FC, useState } from 'react'

import { Checkbox, CheckboxGroup, Collapsible } from '@joor/design-system'

export enum Setting {
  MergeOrders = 'mergeOrders',
  ZipPdfs = 'zipPdfs',
  ExcludeTerms = 'excludeTerms',
  ExcludeImages = 'excludeImages',
}

export type AdvancedSettingsValueType = {
  [Setting.MergeOrders]: boolean
  [Setting.ZipPdfs]: boolean
  [Setting.ExcludeTerms]: boolean
  [Setting.ExcludeImages]: boolean
}

type CheckboxType = {
  id: Setting
  label: string
}

const checkboxes: CheckboxType[] = [
  {
    id: Setting.MergeOrders,
    label: 'Merge orders',
  },
  {
    id: Setting.ZipPdfs,
    label: 'Zip PDFs',
  },
  {
    id: Setting.ExcludeTerms,
    label: 'Exclude terms',
  },
  {
    id: Setting.ExcludeImages,
    label: 'Exclude images',
  },
]

type Props = {
  value: AdvancedSettingsValueType
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const AdvancedSettings: FC<Props> = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(true)
  return (
    <Collapsible
      title="Advanced Settings"
      isOpen={isOpen}
      onClick={(): void => setIsOpen(!isOpen)}
    >
      <CheckboxGroup>
        {checkboxes.map(({ id, label }) => (
          <Checkbox
            key={id}
            id={id}
            label={label}
            checked={value[id]}
            onChange={onChange}
          />
        ))}
      </CheckboxGroup>
    </Collapsible>
  )
}
